
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/AvailChecks/Invited",
      function () {
        return require("private-next-pages/jobs/AvailChecks/Invited/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/AvailChecks/Invited"])
      });
    }
  